export default __webpack_public_path__ + "static/media/hero-title.ab5a2edd.svg";